//------------------------------------------------------------------------------
// BFA10104G 共架申込 通信設備 - 地図/径間ポップアップ
//------------------------------------------------------------------------------
import React from 'react';
import PropTypes from 'prop-types';
import '@esri/calcite-components/dist/components/calcite-action';
import '@esri/calcite-components/dist/components/calcite-list';
import '@esri/calcite-components/dist/components/calcite-list-item';
import {
  CalciteAction,
  CalciteList,
  CalciteListItem,
} from '@esri/calcite-components-react'

// 定数
const LOGH = 'BFA10104G link popup:';

/**
 * 径間ポップアップ/径間一覧描画
 */
export function PopupKeikanList({
  setubiMap,
  keikanList,
  onKeikanEdit,
  onKeikanDelete,
}) {

  // 径間なしの場合
  if (keikanList.length === 0) {
    return <KeikanListNone />;
  }

  // 径間一覧描画
  let index = 0;
  return (
    <CalciteList scale="s"
      style={{
        marginTop: '8px',
        marginLeft: '1px',
        marginRight: '1px',
        border: 'solid 1px #DEDEDE'
      }}
    >
    {
      keikanList.map((keikan) => (
        <KeikanListItem
          key={'keikan-' + index++}
          keikan={keikan}
          setubiMap={setubiMap}
          onKeikanEdit={onKeikanEdit}
          onKeikanDelete={onKeikanDelete}
        />
      ))
    }
    </CalciteList>
  );
}

// プロパティ
PopupKeikanList.propTypes = {
  setubiMap:  PropTypes.instanceOf(Map),     // 架設設備マップ
  keikanList: PropTypes.array.isRequired,    // 架設設備一覧

  // イベントハンドラー
  onKeikanEdit:   PropTypes.func.isRequired,     // 設備編集
  onKeikanDelete: PropTypes.func.isRequired,     // 設備削除
};

// デフォルトエクスポート
export default PopupKeikanList;

/**
 * 径間ポップアップ/径間一覧項目
 */
function KeikanListItem({
  keikan,
  setubiMap,
  onKeikanEdit,
  onKeikanDelete,
}) {

  // 項目選択処理 - 設備編集
  const handleItemSelect = React.useCallback(() => {
    console.log(LOGH, '設備編集', keikan);
    onKeikanEdit(keikan);
  }, [keikan, onKeikanEdit]);

  // 削除ボタン処理 - 設備削除
  const handleItemDelete = React.useCallback((e) => {
    console.log(LOGH, '設備削除', keikan);
    onKeikanDelete(keikan);
  }, [keikan, onKeikanDelete]);

  // 表示文字列
  const setubiName = keikan.setubiCode
      ? setubiMap.get(keikan.setubiCode)
      : '架設設備未設定';
  const label = keikan.bukkenNo
      ? '物件' + keikan.bukkenNo + ' - ' + setubiName
      : setubiName;

  // リスト項目描画
  return (
    <CalciteListItem
      label={label}
      onCalciteListItemSelect={handleItemSelect}
      style={{
        '--calcite-spacing-xxs': 0,  // 上下空白を狭くする
      }}
    >
      {/* 削除ボタン */}
      <CalciteAction
        icon="trash"
        slot="actions-end"
        onClick={handleItemDelete}
      />
    </CalciteListItem>
  );
}

// プロパティ
KeikanListItem.propTypes = {
  keikan:    PropTypes.object.isRequired,    // 架設設備情報
  setubiMap: PropTypes.instanceOf(Map),      // 架設設備マップ

  // イベントハンドラー
  onKeikanEdit:   PropTypes.func.isRequired,     // 設備編集
  onKeikanDelete: PropTypes.func.isRequired,     // 設備削除
};

/**
 * 径間ポップアップ/径間一覧なし
 */
function KeikanListNone() {
  return (
    <div style={{
      marginTop: '8px',
      padding: '2rem 0',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexDirection: 'column',
      border: 'solid 1px #DEDEDE',
      color: 'grey',
    }}>
      <div>径間が登録されていません。</div>
      <div>径間を追加してください。</div>
    </div>
  );
}
